import { memo, useEffect } from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useConnectionStore } from "stores/ConnectionStore";

import { getConnectedServices } from "utility/connections";

import useAnalytics from "effect/use_analytics";

import Destinations from "external/destinations";

import ConnectedDestinations from "./ConnectedDestinations";
import PossibleDestinations from "./PossibleDestinations";

// -----------------------------------------------------------------------------

const EnvironmentDestinations = memo(
  function EnvironmentDestinations(): JSX.Element {
    useAnalytics("Environment: Destinations");

    //
    const [connectionStore, connectionActions] = useConnectionStore();

    //
    useEffect(() => {
      connectionActions.loadConnections({ reload: true });
    }, [connectionActions]);

    const connectedDestinationsCount = getConnectedServices(
      connectionStore?.connections,
      Destinations.services
    ).length;

    //
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="h5" fontWeight="bold" sx={{ mr: 2 }}>
            Available Destinations
          </Typography>
          <Link
            to="/environment/destinations/all"
            style={{
              alignItems: "center",
              display: "flex",
              textDecoration: "none",
              textTransform: "uppercase",
              color: "blue",
            }}
          >
            <Typography variant="body1" color="primary">
              See All Available
              <ArrowForwardIcon sx={{ ml: "4px", width: 16, height: 16 }} />
            </Typography>
          </Link>
        </Box>

        <PossibleDestinations />

        {connectedDestinationsCount > 0 ? (
          <Box sx={{ mt: 4 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Connected Destinations ({connectedDestinationsCount})
            </Typography>

            <ConnectedDestinations />
          </Box>
        ) : null}
      </>
    );
  }
);

export default EnvironmentDestinations;
